import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'splits.devtoolsVisible'
const SYNC_EVENT = 'splits:devtools-visible-change'

const readVisible = () =>
  typeof window !== 'undefined' &&
  window.localStorage.getItem(STORAGE_KEY) === 'true'

const subscribe = (onChange: () => void) => {
  window.addEventListener(SYNC_EVENT, onChange)
  return () => window.removeEventListener(SYNC_EVENT, onChange)
}

export const toggleDevtoolsVisible = () => {
  window.localStorage.setItem(STORAGE_KEY, String(!readVisible()))
  window.dispatchEvent(new CustomEvent(SYNC_EVENT))
}

export const useDevtoolsVisible = () =>
  useSyncExternalStore(subscribe, readVisible, () => false)
